/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelPublicSeminarRegistrationPayload } from '../models/CancelPublicSeminarRegistrationPayload';
import type { CapturePublicSeminarPayPalOrderPayload } from '../models/CapturePublicSeminarPayPalOrderPayload';
import type { ConfirmPublicSeminarStripeCheckoutPayload } from '../models/ConfirmPublicSeminarStripeCheckoutPayload';
import type { ConfirmPublicSeminarStripeCheckoutResponse } from '../models/ConfirmPublicSeminarStripeCheckoutResponse';
import type { CreateExistingSeminarRegistrationCheckoutPayload } from '../models/CreateExistingSeminarRegistrationCheckoutPayload';
import type { CreateSeminarCheckoutSessionPayload } from '../models/CreateSeminarCheckoutSessionPayload';
import type { HoldPublicSeminarSeatsPayload } from '../models/HoldPublicSeminarSeatsPayload';
import type { PublicSeminarCheckoutSessionResponse } from '../models/PublicSeminarCheckoutSessionResponse';
import type { PublicSeminarDetailResponse } from '../models/PublicSeminarDetailResponse';
import type { PublicSeminarHoldResponse } from '../models/PublicSeminarHoldResponse';
import type { PublicSeminarOccurrenceResponse } from '../models/PublicSeminarOccurrenceResponse';
import type { PublicSeminarPaymentConfiguration } from '../models/PublicSeminarPaymentConfiguration';
import type { PublicSeminarPayPalCaptureResponse } from '../models/PublicSeminarPayPalCaptureResponse';
import type { PublicSeminarPayPalClientToken } from '../models/PublicSeminarPayPalClientToken';
import type { PublicSeminarRegistrationResponse } from '../models/PublicSeminarRegistrationResponse';
import type { PublicSeminarsBootstrapResponse } from '../models/PublicSeminarsBootstrapResponse';
import type { RegisterPublicSeminarAsClientPayload } from '../models/RegisterPublicSeminarAsClientPayload';
import type { RegisterPublicSeminarPayload } from '../models/RegisterPublicSeminarPayload';
import type { SelectSeminarPaymentTypePayload } from '../models/SelectSeminarPaymentTypePayload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SeminarsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Bootstrap public seminars for a therapist by slug
     * @param therapistSlug
     * @returns PublicSeminarsBootstrapResponse
     * @throws ApiError
     */
    public getPublicSeminarsBootstrapBySlug(
        therapistSlug: string,
    ): CancelablePromise<PublicSeminarsBootstrapResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/bootstrap/by-slug/{therapistSlug}',
            path: {
                'therapistSlug': therapistSlug,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsBootstrapBySlug(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/bootstrap/by-slug/{therapistSlug}',
        });
    }
    /**
     * Bootstrap public seminars for a therapist
     * @param therapistUuid
     * @returns PublicSeminarsBootstrapResponse
     * @throws ApiError
     */
    public getPublicSeminarsBootstrap(
        therapistUuid: string,
    ): CancelablePromise<PublicSeminarsBootstrapResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/bootstrap/{therapistUuid}',
            path: {
                'therapistUuid': therapistUuid,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsBootstrap(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/bootstrap/{therapistUuid}',
        });
    }
    /**
     * Get a seminar occurrence by public id
     * @param publicId
     * @returns PublicSeminarOccurrenceResponse
     * @throws ApiError
     */
    public getPublicSeminarOccurrence(
        publicId: string,
    ): CancelablePromise<PublicSeminarOccurrenceResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/occurrences/{publicId}',
            path: {
                'publicId': publicId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsOccurrence(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}',
        });
    }
    /**
     * Register for a seminar occurrence
     * @param publicId
     * @param requestBody
     * @returns PublicSeminarRegistrationResponse
     * @throws ApiError
     */
    public registerPublicSeminar(
        publicId: string,
        requestBody: RegisterPublicSeminarPayload,
    ): CancelablePromise<PublicSeminarRegistrationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/occurrences/{publicId}/register',
            path: {
                'publicId': publicId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsRegister(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/register',
        });
    }
    /**
     * Register for a seminar occurrence as an authenticated widget client
     * @param publicId
     * @param requestBody
     * @returns PublicSeminarRegistrationResponse
     * @throws ApiError
     */
    public registerPublicSeminarAsClient(
        publicId: string,
        requestBody: RegisterPublicSeminarAsClientPayload,
    ): CancelablePromise<PublicSeminarRegistrationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/occurrences/{publicId}/register-as-client',
            path: {
                'publicId': publicId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsRegisterAsClient(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/register-as-client',
        });
    }
    /**
     * Hold seats during checkout
     * @param publicId
     * @param requestBody
     * @returns PublicSeminarHoldResponse
     * @throws ApiError
     */
    public holdPublicSeminarSeats(
        publicId: string,
        requestBody: HoldPublicSeminarSeatsPayload,
    ): CancelablePromise<PublicSeminarHoldResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/occurrences/{publicId}/hold',
            path: {
                'publicId': publicId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsHold(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/hold',
        });
    }
    /**
     * Cancel a seminar registration via token
     * @param token
     * @param requestBody
     * @returns PublicSeminarRegistrationResponse
     * @throws ApiError
     */
    public cancelPublicSeminarRegistration(
        token: string,
        requestBody: CancelPublicSeminarRegistrationPayload,
    ): CancelablePromise<PublicSeminarRegistrationResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/registrations/{token}/cancel',
            path: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsCancel(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/registrations/{token}/cancel',
        });
    }
    /**
     * Payment configuration for a seminar occurrence
     * @param publicId
     * @returns PublicSeminarPaymentConfiguration
     * @throws ApiError
     */
    public getPublicSeminarPaymentConfiguration(
        publicId: string,
    ): CancelablePromise<PublicSeminarPaymentConfiguration> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/occurrences/{publicId}/payment-configuration',
            path: {
                'publicId': publicId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsPaymentConfiguration(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/payment-configuration',
        });
    }
    /**
     * Create checkout session for seminar registration
     * @param publicId
     * @param authorization
     * @param requestBody
     * @returns PublicSeminarCheckoutSessionResponse
     * @throws ApiError
     */
    public createPublicSeminarCheckoutSession(
        publicId: string,
        authorization: string,
        requestBody: CreateSeminarCheckoutSessionPayload,
    ): CancelablePromise<PublicSeminarCheckoutSessionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/occurrences/{publicId}/checkout-session',
            path: {
                'publicId': publicId,
            },
            headers: {
                'authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsCheckoutSession(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/checkout-session',
        });
    }
    /**
     * Generate PayPal client token for a seminar occurrence
     * @param publicId
     * @returns PublicSeminarPayPalClientToken
     * @throws ApiError
     */
    public getPublicSeminarPayPalClientToken(
        publicId: string,
    ): CancelablePromise<PublicSeminarPayPalClientToken> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/occurrences/{publicId}/paypal-client-token',
            path: {
                'publicId': publicId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsPayPalClientToken(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/occurrences/{publicId}/paypal-client-token',
        });
    }
    /**
     * Create checkout session for an existing seminar registration
     * Starts Stripe/PayPal checkout for a registration that already exists (e.g. after guest email verification). Auth via cancelToken.
     * @param registrationId
     * @param requestBody
     * @returns PublicSeminarCheckoutSessionResponse
     * @throws ApiError
     */
    public createExistingPublicSeminarCheckoutSession(
        registrationId: number,
        requestBody: CreateExistingSeminarRegistrationCheckoutPayload,
    ): CancelablePromise<PublicSeminarCheckoutSessionResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/registrations/{registrationId}/checkout-session',
            path: {
                'registrationId': registrationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsExistingRegistrationCheckoutSession(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/registrations/{registrationId}/checkout-session',
        });
    }
    /**
     * Choose invoice or cash for an existing seminar registration
     * @param registrationId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public selectSeminarPaymentType(
        registrationId: number,
        requestBody: SelectSeminarPaymentTypePayload,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/registrations/{registrationId}/payment-type',
            path: {
                'registrationId': registrationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsSelectPaymentType(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/registrations/{registrationId}/payment-type',
        });
    }
    /**
     * Confirm a Stripe checkout session for an existing seminar registration
     * @param registrationId
     * @param checkoutSessionId
     * @param requestBody
     * @returns ConfirmPublicSeminarStripeCheckoutResponse
     * @throws ApiError
     */
    public confirmExistingPublicSeminarCheckoutSession(
        registrationId: number,
        checkoutSessionId: string,
        requestBody: ConfirmPublicSeminarStripeCheckoutPayload,
    ): CancelablePromise<ConfirmPublicSeminarStripeCheckoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/registrations/{registrationId}/checkout-sessions/{checkoutSessionId}/confirm',
            path: {
                'registrationId': registrationId,
                'checkoutSessionId': checkoutSessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsConfirmExistingRegistrationCheckoutSession(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/registrations/{registrationId}/checkout-sessions/{checkoutSessionId}/confirm',
        });
    }
    /**
     * Capture a PayPal order for a seminar registration
     * @param registrationId
     * @param requestBody
     * @returns PublicSeminarPayPalCaptureResponse
     * @throws ApiError
     */
    public capturePublicSeminarPayPalOrder(
        registrationId: number,
        requestBody: CapturePublicSeminarPayPalOrderPayload,
    ): CancelablePromise<PublicSeminarPayPalCaptureResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/seminars/registrations/{registrationId}/paypal-capture',
            path: {
                'registrationId': registrationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsCapturePayPalOrder(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/registrations/{registrationId}/paypal-capture',
        });
    }
    /**
     * Public seminar detail by therapist slug
     * @param therapistSlug
     * @param seminarSlug
     * @returns PublicSeminarDetailResponse
     * @throws ApiError
     */
    public getPublicSeminarBySlug(
        therapistSlug: string,
        seminarSlug: string,
    ): CancelablePromise<PublicSeminarDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/by-slug/{therapistSlug}/{seminarSlug}',
            path: {
                'therapistSlug': therapistSlug,
                'seminarSlug': seminarSlug,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsSeminarDetailBySlug(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/by-slug/{therapistSlug}/{seminarSlug}',
        });
    }
    /**
     * Public seminar detail with open occurrences
     * @param therapistUuid
     * @param seminarSlug
     * @returns PublicSeminarDetailResponse
     * @throws ApiError
     */
    public getPublicSeminarDetail(
        therapistUuid: string,
        seminarSlug: string,
    ): CancelablePromise<PublicSeminarDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/seminars/{therapistUuid}/{seminarSlug}',
            path: {
                'therapistUuid': therapistUuid,
                'seminarSlug': seminarSlug,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public publicSeminarsControllerOptionsSeminarDetail(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/seminars/{therapistUuid}/{seminarSlug}',
        });
    }
}
